"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmStepImageStatic
 * @author xlongjiang
 * @created 2025-11-03 10:10:04
 */

const TabPanel = _tpmProductIntl.Tab.TabPanel;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmStepImageStaticData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list;
  const handleList = list.map((item, index) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$icon = item.icon,
      icon = _item$icon === void 0 ? '' : _item$icon,
      _item$tip = item.tip,
      tip = _item$tip === void 0 ? '' : _item$tip,
      _item$itemList = item.itemList,
      itemList = _item$itemList === void 0 ? [] : _item$itemList,
      _item$buttonList = item.buttonList,
      buttonList = _item$buttonList === void 0 ? [] : _item$buttonList,
      _item$img = item.img,
      img = _item$img === void 0 ? '' : _item$img;
    const handleBtnList = buttonList.map((item, key) => {
      const label = item.label,
        href = item.href;
      const buttonExtendProps = {
        'report-event': 'click_StepImage_button',
        'report-ext1': index,
        'report-ext2': key,
        'report-ext3': label || '',
        target: '_blank'
      };
      if (key === 0) {
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: href,
          icon: true,
          align: "center"
        }, buttonExtendProps), label);
      }
      return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        href: href,
        type: 'weak',
        icon: true,
        align: "center"
      }, buttonExtendProps), label);
    });
    const handleItems = itemList.map((item, key) => {
      const title = item.title,
        desc = item.desc,
        linkText = item.linkText,
        linkHref = item.linkHref;
      const linkExtendProps = {
        'report-event': 'click_StepImage_link',
        'report-ext1': index,
        'report-ext2': key,
        'report-ext3': linkText || '',
        target: '_blank'
      };
      return {
        title: title || '',
        desc: desc || '',
        links: linkText && linkHref ? /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
          href: linkHref
        }, linkExtendProps), linkText) : null
      };
    });
    return {
      text: text || '',
      icon: (0, _componentUtils.doComponentsUploadEvent)(icon || '').url,
      tip,
      img: img ? (0, _componentUtils.doComponentsUploadEvent)(img || '').url : null,
      itemList: !!itemList.length ? handleItems : [],
      btns: !!buttonList.length ? handleBtnList : null
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    list: handleList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmStepImageSt = formatTpmStepImageStaticData(data, {
        domains
      }),
      porintId = _formatTpmStepImageSt.porintId,
      tag = _formatTpmStepImageSt.tag,
      title = _formatTpmStepImageSt.title,
      desc = _formatTpmStepImageSt.desc,
      bg = _formatTpmStepImageSt.bg,
      bgColor = _formatTpmStepImageSt.bgColor,
      bgImg = _formatTpmStepImageSt.bgImg,
      list = _formatTpmStepImageSt.list;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmStepImageStatic`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmStepImageStatic', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, list.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: list.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, list.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Step2, {
      img: item.img,
      icon: item.icon,
      text: item.tip,
      items: item.itemList,
      btns: item.btns,
      isLoop: false
    })))) : list.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.Step2, {
      key: index,
      img: item.img,
      icon: item.icon,
      text: item.tip,
      items: item.itemList,
      btns: item.btns,
      isLoop: false
    }))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}